import React, { useState, useEffect } from 'react';
import { Outlet, history } from 'ice';
import { Spin, Modal, Watermark } from 'antd';
import store from '@/store';
import HeaderLayout from './components/Layouts/HeaderLayout';
import { ensureAMapSdkLoaded } from '@/utils/amapSdk';


import styles from './global.less';

export default function Entry(props: {
  children: React.ReactNode;
  pathname: string;
  appLeave: { path: string };
  appEnter: { path: string };
}) {
  const { pathname, children, appLeave, appEnter } = props;
  const [loading, setLoading] = useState(true);
  const [isFetchedUserInfo, setIsFetchedUserInfo] = useState(false);
  const [userInfo, setUserInfo] = useState(store.getState().user);

  useEffect(() => {
    // 统一预加载 AMap SDK，供子应用复用。
    // 失败不阻塞主应用渲染，子应用可自行决定兜底策略（如提示/刷新）。
    ensureAMapSdkLoaded().catch((e) => {
      console.warn('AMap SDK preload failed:', e);
    });
  }, []);

  const handleJumpTo = (path: string) => {
    console.log('handleJumpTo', path, history, "appLeave:", appLeave, "appEnter:", appEnter);
    history?.push(path);
  }
  const handleLogout = () => {
    window.location.replace('/api/perms/logout');
  }
  // 订阅 store 变化
  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      setUserInfo(store.getState().user);
    });
    return unsubscribe;
  }, []);

  // 页面加载逻辑
  useEffect(() => {
    const loadUserData = async () => {
      // 如果是登录页面，不需要加载用户数据
      if (pathname === '/login' || isFetchedUserInfo) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        await store.dispatch.user.asyncGetUserInfo();
        setLoading(false);
        setIsFetchedUserInfo(true);
      } catch (error) {
        console.error('获取用户信息失败:', error);
        // 跳转到登录页面
        window.location.href = '/login';
      }
    };
    if (userInfo.userId) {
      setLoading(false);
      return;
    } else {
      loadUserData();
    }
  }, [pathname, isFetchedUserInfo]);

  useEffect(() => {
    console.log('== app leave ==', appLeave);
  }, [appLeave]);

  useEffect(() => {
    console.log('== app enter ==', appEnter);
  }, [appEnter]);

  // 登录页面直接渲染，不需要布局
  if (pathname === '/login' || pathname === '/login-success' || pathname === '/exception/403' || pathname === '/exception/404') {
    return (
      <>
        {children || <Outlet />}
      </>
    );
  }

  // 加载中状态
  if (loading) {
    return (
      <div className={styles.globalLoading}>
        <Spin size="large" spinning={true}>
          <div style={{ width: '100%', height: '100vh' }} />
        </Spin>
      </div>
    );
  }

  const watermarkContent = userInfo.userName && userInfo.mobile
    ? `${userInfo.userName} ${userInfo.mobile.slice(-4)}`
    : 'Loading...';

  return (
    <>
      <Watermark
        content={watermarkContent}
        font={{ color: 'rgba(0, 0, 0, 0.05)' }}
      >
        <HeaderLayout
          pathname={pathname}
          handleLogout={handleLogout}
          handleJumpTo={handleJumpTo}
          userInfo={userInfo}>
          {children}
        </HeaderLayout>
      </Watermark>
    </>

  );
}
